<template>
  <el-select
    :loading="loading"
    :value="selected"
    :placeholder="placeholderI18n"
    :disabled="disabled"
    @change="updateCompany"
  >
    <el-option
      v-for="{ name, id } in companies"
      :key="name"
      :label="$t(`companiesFilter.${name}`)"
      :value="id"
    />
  </el-select>
</template>
<script>
import { mapState } from 'vuex';
import { DEFAULT_COMPANY } from '@/constants';

export default {
  name: 'CompanyDropdown',
  props: {
    selected: {
      type: Number,
      default: DEFAULT_COMPANY,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$emit('change', this.selected);
  },
  computed: {
    ...mapState('companies', { companies: (state) => state.companies }),
    loading() {
      return !this.companies.length;
    },
    placeholderI18n() {
      return this.$t('settings.dropDownPlaceholder');
    },
  },
  methods: {
    updateCompany(company) {
      this.$emit('change', company);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';

.el-select-dropdown {
  &__item {
    font-family: 'Avenir';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CompanyDropdown.vue